import { ChecklistFieldType } from '@cobliteam/api-lib';
import Icon, { type IconNames } from '@cobliteam/ui/icons';
import type React from 'react';

interface ChecklistIconProps {
  type: ChecklistFieldType;
  className?: string;
}

const ChecklistIcon: React.FC<ChecklistIconProps> = ({ type, className }) => {
  const iconName = {
    [ChecklistFieldType.CHECK]: 'circle-check',
    [ChecklistFieldType.TEXT]: 'text',
    [ChecklistFieldType.MULTI_SELECT]: 'list-checks',
    [ChecklistFieldType.SINGLE_SELECT]: 'circle-dot',
  }[type];

  return <Icon name={iconName as IconNames} className={className} />;
};

export default ChecklistIcon;
